import styled from 'styled-components';

const SearchWrap = styled.div`
  flex-shrink: 0;
  min-width: 0;
  max-width: 200px;
  overflow: hidden;
`;

export default SearchWrap;
